import { useMutation } from "@tanstack/react-query";
import column_services from "services/column_services";
import { SettlementAccountStatus } from "types/stripe";
import { CreateColumnCounterpartyInput } from "types/column";

export function useColumnCounterparty() {
  const createMutation = useMutation<
    SettlementAccountStatus,
    Error,
    { merchantId: string; input: CreateColumnCounterpartyInput }
  >({
    mutationFn: ({ merchantId, input }) =>
      column_services.createCounterparty(merchantId, input),
  });

  return {
    createCounterparty: createMutation.mutateAsync,
    creating: createMutation.isPending,
  };
}
